module.exports = __webpack_public_path__ + "img/1.d4711a8e.png";